// extracted by mini-css-extract-plugin
export var askAiIcon = "_of-k";
export var category = "_of-a";
export var categoryHeader = "_of-f";
export var container = "_of-0";
export var group = "_of-b";
export var groupItems = "_of-g";
export var groupSeparator = "_of-l";
export var highlight = "_of-8";
export var loading = "_of-1";
export var noResults = "_of-3";
export var placeholder = "_of-2";
export var resultContent = "_of-5";
export var resultIcon = "_of-d";
export var resultItem = "_of-h";
export var resultMeta = "_of-9";
export var resultSubtitle = "_of-7";
export var resultSuffix = "_of-j";
export var resultTitle = "_of-6";
export var resultsList = "_of-4";
export var searchGroup = "_of-e";
export var selected = "_of-i";
export var subgroup = "_of-c";